export default "__VITE_ASSET__CPfYXEj$__"